export enum PlusAppliesOnEnum {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  WEEKENDS = "WEEKENDS",
  WORKDAYS = "WORKDAYS",
  HOLIDAYS = "HOLIDAYS",
}
